import { Autocomplete, Grid, Paper, TextField, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SyntheticEvent, useContext } from "react";
import { useState } from "react";
import { CURRENT_ATTRIBUTE_DMS, CUR_ATTR_BY_STATUS_DMS, CUR_STATUS_DMS } from "../../data";
import { FormAutocomplete, FormTextField } from "../../common/form-fields-wrappers";
import { Controller, FormProvider } from "react-hook-form";
import ActionFilters from "./ActionFilter";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";


const typeOptions = [
    'Aeroporti',
    'Stazioni ferroviarie',
    'Credit Agricole',
    'Harbour',
    'Mall',
    'Retailer',
    'Reserve',
    'Other'
];

const currentStatusOptions = [
    'Contractualized',
    'Associated',
    'Terminated'
];

const ContractorFilter = ({ searchContractorForm, handleSearch, filterExpandedState }: any) => {
    const theme = useTheme();
    const { t } = useTranslation(['network', 'translation']);
    const {globalData} = useContext(GlobalContext);
    const legalEntities = globalData.user?.legalEntities;
    const [dealers, setDealers] = useState<any[]>([]);
    const {errors} = searchContractorForm.formState;

    const [curAttributes, setCurAttributes] = useState<string[]>(CURRENT_ATTRIBUTE_DMS);

    const handleChangeStatus = (_e: SyntheticEvent, value: any) => {
        searchContractorForm.setValue('currentAttribute', '');
        const curStatus = value as (CUR_STATUS_DMS | undefined) || 'DEFAULT';
        // @ts-ignore
        setCurAttributes(CUR_ATTR_BY_STATUS_DMS[curStatus]);
    }

    return (
        <Paper elevation={1} sx={{ p: theme.spacing(2), mb: theme.spacing(2) }}>
            <FormProvider {...searchContractorForm}>
                <form onSubmit={searchContractorForm.handleSubmit(handleSearch)}>
                    <Grid container columnSpacing={2}>
                        <Grid item xs={6} md={3} sx={{ display: "flex", alignItems: "center" }}>
                            <FormTextField
                                name='companyName'
                                control={searchContractorForm.control}
                                label={t("contractorMng.openRoyalityFeesManagement.form.labels.companyName")}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormAutocomplete
                                name="currentStatus"
                                control={searchContractorForm.control}
                                label={t("contractorMng.openRoyalityFeesManagement.form.labels.currentStatus")}
                                fullWidth
                                options={currentStatusOptions}
                                isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                                getOptionLabel={(opt: any) => opt ? t(`contractorMng.openRoyalityFeesManagement.form.labels.currentStatusValues.${opt}`) : ''}
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormAutocomplete
                                name="type"
                                control={searchContractorForm.control}
                                label={t("contractorMng.openRoyalityFeesManagement.form.labels.type")}
                                fullWidth
                                options={typeOptions}
                                isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                                getOptionLabel={(opt: string) => !!opt ? t(`contractorMng.openRoyalityFeesManagement.form.labels.typeValues.${opt}`) : ''}
                            />
                        </Grid>

                        <ActionFilters
                            filterExpandedState={filterExpandedState}
                            handleSearch={handleSearch}
                            searchDmsForm={searchContractorForm}
                            setCurAttributes={setCurAttributes}
                        />

                    </Grid>

                    {filterExpandedState[0] &&
                        <Grid container item xs={12} columnSpacing={2} sx={{ mt: theme.spacing(2) }}>
                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='icaoCode'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.icaoCode")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3} sx={{ display: "flex", alignItems: "center" }}>
                                <FormTextField
                                    name='bpCode'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.bpCode")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='iataCode'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.iataCode")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='vatNumber'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.vatNumber")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='country'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.country")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='province'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.province")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='region'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.region")}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <FormTextField
                                    name='city'
                                    control={searchContractorForm.control}
                                    label={t("contractorMng.openRoyalityFeesManagement.form.labels.city")}
                                    fullWidth
                                />
                            </Grid>

                            {legalEntities.length > 1 &&
                                <Grid item md={3} xs={12}>
                                    <Controller
                                        control={searchContractorForm.control}
                                        name="tenants"
                                        render={({ field: { onChange, value } }: any) => (
                                            <Autocomplete
                                                limitTags={1}
                                                disableCloseOnSelect={true}
                                                multiple
                                                id={'tenants'}
                                                options={legalEntities}
                                                value={value || []}
                                                getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        label={t("searchDms.form.label.legalEntities")}
                                                        error={Boolean(errors?.tenants)}
                                                        helperText={t(errors?.tenants?.message as string)}
                                                    />
                                                )}
                                                onChange={(event, value) => {
                                                    let tmpDealers = globalData.user?.dealers?.filter((dealer: any) => {
                                                        if (value?.length > 0) {
                                                            return value?.find((legalEntity: any) => legalEntity.id === dealer.legalEntities[0].id);
                                                        } else {
                                                            return dealer;
                                                        }
                                                    });
                                                    setDealers(tmpDealers);
                                                    searchContractorForm.setValue('dealers', []);
                                                    onChange(value);
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                        </Grid>
                    }
                </form>
            </FormProvider>
        </Paper>
    )
}

export default ContractorFilter;
